import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type AuthButtonProps = {
  disabled: boolean
  busy: boolean
  children: React.ReactNode
} & ClassNameProps

export const AuthButton: React.FC<AuthButtonProps> = ({
  disabled,
  busy,
  children,
  className,
}) => (
  <ButtonAlt
    size="s"
    type="submit"
    disabled={disabled}
    busy={busy}
    color="primary"
    variant="solid"
    radius="rounded"
    className={className}
  >
    {children}
  </ButtonAlt>
)

const ButtonAlt = styled(Button)``
